import axios from 'axios';
import React, {useState, useEffect, useMemo, Fragment, useRef} from 'react';

import { FormControl, InputLabel, Input, FormHelperText, Alert } from '@mui/material';
import WebService from '@util/webService'
import {encodeParams, getAction, getCodeName, printVariable} from '@util/helper'
// redux
import { useSelector, useDispatch } from 'react-redux';
// MUI Table
import CssBaseline from '@mui/material/CssBaseline'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
// react-table
import { useTable, useExpanded } from 'react-table'
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Checkbox, FormGroup, FormControlLabel, Typography, Snackbar, TablePagination, TextField,withStyles,InputBase } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
import '@scss/App.scss'
import Button from '@mui/material/Button'
import FlatButton from '@components/FlatButton';
import useSnackbar from '@hooks/useSnackbar';
import MyTableHead from '@components/MyTableHead';
import useIndicator from '@hooks/useIndicator';
import Indicator from '@components/Indicator';
import MyDialog from '@components/MyDialog';
import useForm from '@hooks/useForm';
import Box from '@mui/material/Box';
import { useLocation } from 'react-router-dom';
// pagination
import { useTheme } from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import {
  Avatar,
  Grid,
  Container,
} from '@mui/material/';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import moment from 'moment';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { searchSchool } from '@util/helper';

import ProfileCompanyManagerPart from './profile-company.manager.part';
import {useParams} from "react-router-dom";

import ConfirmDialog from "@components/ConfirmDialog";

import useAlert from "@hooks/useAlert";


const Boxs = styled(Box)`
      padding-bottom: 40px !important;
    `;


const FormHelperTexts = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
`;

const ProfileDirectManagerPage = () => {
  const {more} = useParams()
  const fields = [
    {field: 'id', placeholder: 'ID',    type:'text', value:-1, visible: more && (more === 'more'), canSrch: false, selList:[]},
    {field: 'userName', placeholder: '매니저명',    type:'text', value:'', visible: true, canSrch: false,selList:[]},
    {field: 'rltnCode', placeholder: '관계코드',    type:'text', value:'', visible: false, canSrch: false,selList:[]},
    {field: 'rltnName', placeholder: '관계',    type:'text', value:'', visible: true, canSrch: false,selList:[]},
    {field: 'statCode', placeholder: '상태코드',    type:'text', value:'', visible: false, canSrch: false,selList:[]},
    {field: 'statName', placeholder: '상태',    type:'text', value:'', visible: true, canSrch: false,selList:[]},
  ]
  const visibleColumns = fields.filter(col => col.visible)
  const defRecord = {}
  fields.forEach(d => {
    defRecord[d.field] = d.value
  })
  defRecord.schoolList = []
  const recordRef = useRef(defRecord)
  const defTerms = {}
  fields.filter(col => col.canSrch).map(d => d.field).forEach(d => defTerms[d] = '')
  const [companyList, set_companyList] = useState([])
  const [dataList, set_dataList] = useState([])
  const [skipPageReset, setSkipPageReset] = React.useState(false)
  const [openSnackbar, renderSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const dgHandler = useState(false)
  const [selIdx, set_selIdx] = useState(-1)
  const [pageNum, set_pageNum] = useState(0)
  const [pageSize, set_pageSize] = useState(10)
  const [totalCount, set_totalCount] = useState(0)
  const [pageInfo, set_pageInfo] = useState({pageNum:0, pageSize: 10})
  const [terms, _set_terms] = useState(defTerms)
  const termsRef = useRef(terms)
  const location = useLocation()
  const curLocationRef = useRef(location)
  // redux
  const codeGroups = useSelector(state => state.codeGroupReducer)
  const codes = useSelector(state => state.codeReducer)
  const account = useSelector(state => state.accountReducer)
	const schola = useSelector((state) => state.scholaReducer)

  const {alert, renderAlert} = useAlert()
  
  const set_terms = data => {
    termsRef.current = data
    _set_terms(data)
  }


  useEffect(() => {
    onLoad()
  }, [pageInfo])

  useEffect(() => {
  if(curLocationRef.current.key !== location.key) {
     set_pageInfo({ pageNum: 0, pageSize: 10 })
     curLocationRef.current = location
    }
  }, [location])
  
  const onLoad = async() => {
    openIndicator()
    const url = `/rltn/direct/user/${account.user.id}/S005`
    const resp = await WebService.get(url, {schoolId:schola.id})
    if(resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage)
      const records = JSON.parse(repMessage.records)
      records.forEach(r => {
        r.userName = r.user.name
        r.rltnName = getCodeName(codes, 'SA04', r.rltnCode)
        r.statName = getCodeName(codes, 'SA18', r.statCode)
      })
      records.sort((a,b) => a.userName.localeCompare(b.userName))
      set_dataList(records)
    }
    else {
      openSnackbar(resp.repMessage)
    }
    closeIndicator()
  }

  const onDetail = async(id) => {
    dgHandler[1](true)
  }

  const onResolve = async(rltnId, statCode) => {
    const url = `/rltn/company/user/resolve/${rltnId}`
    const params = {statCode: statCode}
    openIndicator()
    const resp = await WebService.post(url, {}, params)
    closeIndicator()

    if(resp.repCode === 'ack') {
      alert('처리되었습니다.')
      onLoad()
    }
    else {
      alert(resp.repMessage)
    }
  }

  const delCompanyUserRltn = async (id) => {
    const url = `/rltn/company/user/${id}`
    const resp = await WebService.delete(url)
    console.log('resp =>', resp)
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    alert('삭제되었습니다.', () => onLoad())
  }
  

  
  const onCreate = () => {
    recordRef.current = defRecord
    dgHandler[1](true)
  }

  const onSearch = () => {
    onLoad()
  }

  const onClear = () => {
    const obj = {}
    Object.keys(terms).forEach(k => {
      obj[k] = ''
    })
    set_terms(obj)
  }

  const handleChangePage = (event, newPage) => {
    set_pageInfo({...pageInfo, pageNum: newPage })
  }
  
  const handleChangeRowsPerPage = (event) => {
    
    const pageSize = parseInt(event.target.value, 10)
    set_pageInfo({pageNum:0, pageSize: pageSize})
  }

  const TablePaginationActions = (props) => {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    );
  }

  // const dg_title = '소속 매니저'
  // const memo_DgContent = useMemo(()=> {return <ProfileCompanyManagerPart company={record.company} manager={record.user}/>}, [record])
  if(dataList != null) {
    return (
      <div >
        {/*<MyDialog title={dg_title} component={memo_DgContent} dialogHandler={dgHandler}/>*/}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}>
          <div style={{ paddingRight: 10 }}>
            <h1>학교 매니저 목록</h1>
          </div>
        </div>
        
        <div style={{paddingTop:20, }}>
          <MUITable>
            <MyTableHead >
              <TableRow>
                <TableCell>No.</TableCell>
                {
                  fields.map((col, index) => {
                    if(col.visible) {
                      return(
                        <TableCell key={index} size='small' key={col.field}>
                          {col.placeholder}
                          {col.canSrch? 
                            ( 
                              <Fragment>
                                  <TextField label="" variant="outlined" size='small' inputProps={{style: {fontSize: '0.875em', padding:5, backgroundColor:'#fff'}}} 
                                    value={terms[col.field]}
                                    onChange={(e) => {
                                      const newTerms = {...terms}
                                      newTerms[col.field] = e.target.value
                                      set_terms(newTerms)
                                    }}
                                  />
                              </Fragment>
                            )
                            : (
                              <Fragment>
                              </Fragment>
                            )
                          }
                        </TableCell>
                      )
                    }
                  })
                }
                <TableCell size='small' style={{display:'flex', }}>
                  관리
                  {/* 
                  <FlatButton size='small' variant='outlined' style={{marginRight:5}} color='primary' onClick={onSearch}>검색</FlatButton>
                  <FlatButton size='small' variant='outlined'  color='primary' onClick={onClear}>지우기</FlatButton>
                  */}
                  
                </TableCell>
              </TableRow>
            </MyTableHead>
            <TableBody>
              {
                dataList.map((row, index) => {
                  return(
                    <Fragment key={index}>
                      <TableRow onMouseEnter={()=> {
                        recordRef.current = row
                      }}>
                          <TableCell>{index + 1}</TableCell>
                          {
                            fields.map((col, index2) => {
                              if(col.visible) {
                                return(
                                  <TableCell key={index2} size='small'>
                                    {row[col.field]}
                                  </TableCell>
                                )
                              }
                            })
                          }
                          <TableCell size='small'>
                            <FlatButton variant='outlined' size='small'  style={{marginRight:5}} onClick={() => onDetail(row.id)}>보기/학교설정</FlatButton>
                            {/* <FlatButton variant='outlined'  color='error' size='small' onClick={() => onDelete(row.id)}>삭제</FlatButton>*/}
                            <ConfirmDialog
                              btn={<FlatButton style={{marginRight:5}} disabled={row.statCode !== 'S001'}>승인</FlatButton>}
                              title={'알림'}
                              content={'승인 처리 하시겠습니까?'}
                              bc={'primary'}
                              preHandle={ async () => {
                                return true
                              }}
                              perform={() => {
                                onResolve(row.id, 'S002')
                              }}
                            />
                            <ConfirmDialog
                              btn={<FlatButton color='warning' style={{marginRight:5}} disabled={row.statCode !== 'S001'}>거부</FlatButton>}
                              title={'알림'}
                              content={'데이터는 삭제됩니다. 거부 처리 하시겠습니까?'}
                              bc={'warning'}
                              preHandle={ async () => {
                                return true
                              }}
                              perform={() => {
                                onResolve(row.id, 'DEL')
                              }}
                            />
                            <ConfirmDialog
                              btn={<FlatButton color='warning' style={{marginRight:5}} disabled={row.statCode !== 'S002'}>삭제</FlatButton>}
                              title={'알림'}
                              content={'해당 매니저를 삭제하면, 다시 재신청/승인 절차를 거쳐야 매니저 업무를 할 수 있습니다. 삭제하시겠습니까? '}
                              bc={'warning'}
                              preHandle={ async () => {
                                return true
                              }}
                              perform={() => {
                                delCompanyUserRltn(row.id)
                              }}
                            />
                            {/*<FlatButton variant='contained' size='small'  style={{marginRight:5}} onClick={() => onResolve(row.id, 'S002')} disabled={row.statCode !== 'S001'}>승인2</FlatButton>*/}
                            {/*<FlatButton variant='contained' size='small'  style={{marginRight:5}} onClick={() => onResolve(row.id, 'DEL')} disabled={row.statCode !== 'S001'}>거부</FlatButton>*/}
                          </TableCell>
                        </TableRow>
                      </Fragment>
                  )
                })
              }
            </TableBody>
            <TableFooter>
            <TableRow>

            </TableRow>
          </TableFooter>
          </MUITable>
          {dgHandler[0] ? (<ProfileCompanyManagerPart company={recordRef.current.company} manager={recordRef.current.user} dialogHandler={dgHandler} />) : null}
           {renderSnackbar()}
           {renderIndicator()}
          {renderAlert()}
          </div>

      </div>
      
    );
  }
  
}

export default ProfileDirectManagerPage
